import React from "react";
import { useDispatch } from "react-redux";

import { IgLink, IgTypography } from "@intelligems/ig-theme";
import { MetricArrayType } from "@intelligems/ig-types";
import { AlertTitle, Grid } from "@mui/material";

import { calculateCogsWarning } from "../../../api/formatters/dashboard";
import { IgAlert } from "../../../components/Utils/IgAlert";
import { setDialog } from "../../../store/slices/global";

import { DataExportDialog } from "./DataExportDialog";

interface CogsWarningProps {
  dashboardProfitData: MetricArrayType | undefined;
}
export const CogsWarning = ({ dashboardProfitData }: CogsWarningProps) => {
  const dispatch = useDispatch();

  if (!dashboardProfitData) {
    return null;
  } else {
    const warningCalc = calculateCogsWarning(dashboardProfitData);

    if (warningCalc && warningCalc > 0.1) {
      return (
        <Grid container item sx={{ marginBottom: "15px" }}>
          <IgAlert
            severity={"warning"}
            title={
              "Warning: We may be missing COGS information for products sold during the test"
            }
            longMessage={
              <IgTypography>
                We may be missing COGS information for products sold during the
                test. Use the{" "}
                <IgLink
                  onClick={() => {
                    dispatch(setDialog({ dialog: "dataExport", open: true }));
                  }}
                >
                  export of order line items
                </IgLink>{" "}
                to see which COGS information is missing. Please note items with
                no associated COGS contribute to profit figures with 100% margin
                which may skew results.
              </IgTypography>
            }
          />
          <DataExportDialog />
        </Grid>
      );
    } else return null;
  }
};
